module.exports = __webpack_public_path__ + "static/img/banner_e.bc070b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner_e.jpg
// module id = ndUX
// module chunks = 1